import { Position } from "@blueprintjs/core"
import * as PortalAction from "@src/Actions/PortalActions"
import { ButtonSecondary } from "@src/Components/Button"
import { usePortalSize } from "@src/Components/Common/usePortalSize"
import ZegPanel from "@src/Components/Common/ZegPanel"
import ThreeDotMenu from "@src/Components/ThreeDotMenu"
import { ContentArea } from "@src/Components/View"
import { SETTINGS_ACTION_COLLAPSE_BREAKPOINT } from "@src/Constants"
import C from "@src/Controller"
import { VIEW_PATHS } from "@src/Routes/constants"
import * as T from "@src/types"
import * as React from "react"
import { useDispatch } from "react-redux"
import { useHistory } from "react-router"
import styled from "styled-components"

interface ISettingsContainer {
  children: JSX.Element
}

export const settingsTabs = [
  { id: "you", text: "Your Details", shortText: "Your Details" },
  {
    id: "organization",
    text: "Organization Details",
    shortText: "Organization Details",
  },
  {
    id: "admins",
    text: "Manage Cyber Safety Admins",
    shortText: "Manage Admins",
  },
]

const ManageSubscriptionBtn = styled(ButtonSecondary)`
  width: auto;
  white-space: nowrap;
  padding: 6px 16px;
  font-size: 16px;
  flex-shrink: 0;
  margin-bottom: 10px;
  margin-left: 28px;
  border-radius: 32px;
  letter-spacing: 2%;
`

const SettingsContainer = ({ children }: ISettingsContainer) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const { clientWidth, isDesktop } = usePortalSize()
  const paths = history.location.pathname.split("/")
  const tabPath = paths[2]

  const navigateToSubscription = () => {
    dispatch(PortalAction.setPortalMenu("subscription"))
    history.push(VIEW_PATHS.subscription)
  }

  const renderHeaderAction = () => {
    if (!isDesktop) {
      return undefined
    }

    if (clientWidth < SETTINGS_ACTION_COLLAPSE_BREAKPOINT) {
      return (
        <ThreeDotMenu
          menuItems={[
            {
              caption: "Manage Subscription",
              action: navigateToSubscription,
            },
          ]}
          position={Position.BOTTOM_RIGHT}
        />
      )
    }

    return (
      <ManageSubscriptionBtn onClick={navigateToSubscription}>
        Manage Subscription
      </ManageSubscriptionBtn>
    )
  }

  React.useEffect(() => {
    C.Portal.getUserList()
    C.Portal.getUserInviteList()
    C.heapTrack("Viewed Settings")
  }, [])

  return (
    <ContentArea>
      <ZegPanel
        tabs={settingsTabs}
        onTabChange={(id) => history.push(`${T.ViewTypes.settings}/${id}`)}
        selectedTabId={tabPath}
        headerAction={renderHeaderAction()}
      >
        {children}
      </ZegPanel>
    </ContentArea>
  )
}

export default SettingsContainer
